
<template></template>
<script>
    /* eslint-disable */
    import store from '../../store'
    export default {
        mounted () {
            localStorage.removeItem('token')
            localStorage.removeItem('expiration')
            store.commit('logOutUser')
            this.$router.push({ name: 'Login-Layout' })
            console.log('response => ', 'This is logout');
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/auth/logout.vue